<script lang="ts">
    type Link = {
        url: string;
        text: string;
    }

    interface Props {
        whatThisPageIsAbout: string;
        link1: Link;
        link2: Link;
    }

    // prettier-ignore
    let {
        whatThisPageIsAbout,
        link1,
        link2,
    }: Props = $props()
</script>

<!-- NOTE link to the two previous lists -->

<h2>
    What’s Next? Keep Building Your German Vocabulary!
</h2>
<p>
    Mastering {whatThisPageIsAbout} is a great milestone in your learning journey — but why stop there? Expand your
    vocabulary even further with our guides to the <a href={link1.url}>{link1.text}</a> and the <a
        href={link2.url}>{link2.text}</a>. Each list is packed with useful words and example sentences to help you speak
    and understand German more confidently.
</p>
<p>
    Ready to put these words into practice? Visit <b>vocabeo</b>'s <a href="/learn">Learning Area</a> to
    review, test yourself, and keep making progress every day.
</p>
<p>
    Looking for more topics? Explore all <a href="/german-vocabulary">German vocabulary lists</a> 📚
</p>
